import { Field } from 'formik'
import { get, isObject } from 'lodash'

/**
 * Depricated - Can remove once the original Workflows UI is deleted
 */

const getNestedErrors = (errors: any) => {
  if (isObject(errors)) {
    const objectKeys = Object.keys(errors)
    // @ts-expect-error
    return objectKeys.map(key => ({ errorLabel: errors[key], id: key }))
  }
  return
}

/**
 * withField - A higher order component to connect a component to Formik without using `connect()`
 *
 * `connect()` injects the entire form state into the component, even if it is nested below another field.
 * When the connected Formik state updates, it causes a rerender on the component
 * Which is a problem when using `connect()` with nested fields, all components are forced to rerender when any of them change
 */
const withField = (WrappedComponent: any) => {
  return function FieldWrapper(props: any) {
    return (
      <Field name={props.name}>
        {({ field: { value, onChange }, form: { setFieldValue, errors, touched } }: any) => {
          const isTouched = get(touched, props.name)
          const fieldErrors = get(errors, props.name)

          const errorRows = props.nestedErrors ? getNestedErrors(fieldErrors) : fieldErrors

          return (
            <div className="column no-grow">
              <WrappedComponent
                onChange={onChange}
                errors={isTouched ? fieldErrors : undefined}
                value={value}
                setFieldValue={setFieldValue}
                {...props}
              />
              {errorRows && isTouched && (
                <div data-testid="error" className="field__error">
                  {props.nestedErrors
                    ? errorRows.map((err: any) => (
                        <span className="row" key={`error-${err.id}`}>
                          {err.errorLabel}
                        </span>
                      ))
                    : fieldErrors}
                </div>
              )}
            </div>
          )
        }}
      </Field>
    )
  }
}

export default withField
